<script setup lang="ts">
import { setupGlobalErrors } from '@/composables/useErrors';

// Renderless: lives inside <BApp> so useToast() can resolve its injection.
// Caches the toast service for non-component callers (Pinia Colada global hooks).
setupGlobalErrors();
</script>

<template></template>
